var map = {
	"./bg-hero-small.svg": 24,
	"./bg-hero.svg": 25,
	"./bg-traiangle-2.svg": 26,
	"./bg-triangle-alt.svg": 27,
	"./bg-triangle-clean.svg": 28,
	"./bg-triangle-popup.svg": 29,
	"./bg-triangle.svg": 30,
	"./bg-triangles-left-graph.svg": 31,
	"./bg-triangles-right-graph.svg": 32,
	"./bomencampus-logo-simple.svg": 33,
	"./bomencampus-logo.svg": 34,
	"./icon-arrow-left.svg": 35,
	"./icon-arrow-right.svg": 36,
	"./icon-caret-down-dark.svg": 37,
	"./icon-caret-down.svg": 38,
	"./icon-checklist.svg": 39,
	"./icon-checkmark-bold.svg": 40,
	"./icon-checkmark.svg": 41,
	"./icon-duration.svg": 42,
	"./icon-eye.svg": 43,
	"./icon-facebook.svg": 44,
	"./icon-file.svg": 45,
	"./icon-filter.svg": 46,
	"./icon-handle.svg": 47,
	"./icon-instagram.svg": 48,
	"./icon-leaf-1-bg.svg": 49,
	"./icon-leaf-2-bg.svg": 50,
	"./icon-leaf-3-bg.svg": 51,
	"./icon-leaf.svg": 52,
	"./icon-level.svg": 53,
	"./icon-link.svg": 54,
	"./icon-linkedin.svg": 55,
	"./icon-mail.svg": 56,
	"./icon-phone.svg": 57,
	"./icon-plus.svg": 58,
	"./icon-quotes.svg": 59,
	"./icon-time.svg": 60,
	"./icon-tooltip.svg": 61,
	"./icon-tree.svg": 62,
	"./icon-triangle-up-default.svg": 63,
	"./icon-twitter.svg": 64,
	"./icon-whatsapp.svg": 65,
	"./icon-youtube.svg": 66,
	"./list-item-down.svg": 67,
	"./list-item.svg": 68,
	"./loader.svg": 69,
	"./login-tree.svg": 70,
	"./talent-arrows.svg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;